
export function sanitize(value) {
    if (value) {
        value = value.toString()
        value = value === value.toUpperCase() && value.toLowerCase() || value
        value = value.charAt(0).toLowerCase() + value.slice(1)
        value = value.replace(/[-_\s]([a-z])/g, (m) => m[1].toUpperCase())
    }
    return value
}

export function replace(value, data = {}) {
    if (value) {
        value = value.toString()

        Object.keys(data).forEach((key) => {
            if (data[key] === true) {
                // remove key
                value = value.replace('{' + sanitize(key) + '}', '')
            } else  if (data[key] != null && data[key] !== false) {
                // replace key
                value = value.replace('{' + sanitize(key) + '}', data[key])
            }
        })
        // remove optional text with unmatched keys
        value = value.replace(/\[\[([^\[\]]*{[\w]+}[^\[\]]*)+\]\]/g, '')
        // remove brackets
        value = value.replace(/\[\[([^\[\]]*)\]\]/g, '$1')
        // remove unmatched keys
        value = value.replace(/{[\w]+}/g, '')
    }
    return value
}

export default function(target, key = [], defaultValue) {
    const keySet = (key instanceof Array) && key || [key]

    if (typeof target == 'string') {
        return target
    }

    if (typeof target == 'object') {
        var keySanitized
        var value

        for (var i = 0 ; i < keySet.length ; i++) {
            keySanitized = sanitize(keySet[i])

            value = target[keySanitized]
            value = value && value.default || value
            if (value) break
        }

        if (defaultValue === undefined) {
            return value || keySanitized    
        }
        return value || defaultValue
    }

    return 'invalid extraction'
}


// WEBPACK FOOTER //
// ./lib/core/extract.js